<template>
  <div class="max-w-3xl mx-auto">
    <div class="flex justify-between items-center mb-6">
      <h2 class="text-lg font-bold">{{ __("Operations") }}</h2>
      <inertia-link :href="route('settings.operations.create')" class="btn-primary">
        {{ __("Add operation") }}
      </inertia-link>
    </div>

    <table class="w-full border" aria-describedby="Operations table">
      <thead class="bg-gray-100">
        <tr>
          <th id="op-id" class="text-left p-2 w-20">{{ __("ID") }}</th>
          <th id="op-name" class="text-left p-2">{{ __("Name") }}</th>
          <th id="op-actions" class="text-right p-2 w-40">{{ __("Actions") }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="op in operations.data" :key="op.id" class="border-t">
          <td class="p-2">{{ op.id }}</td>
          <td class="p-2">{{ op.name }}</td>
          <td class="p-2 text-right">
            <inertia-link :href="route('settings.operations.edit', { operationCatalog: op.id })" class="text-coral-500 hover:text-coral-400 mr-4">
              {{ __("Edit") }}
            </inertia-link>
            <button type="button" @click="destroy(op)" class="text-red-500 hover:text-red-400">
              {{ __("Delete") }}
            </button>
          </td>
        </tr>
        <tr v-if="operations.data.length === 0">
          <td colspan="3" class="p-6 text-center text-gray-500">
            {{ __("No operations yet.") }}
          </td>
        </tr>
      </tbody>
    </table>

    <pagination :links="operations.links"/>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout';
import SettingsLayout from '@/Shared/SettingsLayout';
import Pagination from '@/Shared/Pagination';

export default {
  layout: (h, page) => h(Layout, [h(SettingsLayout, [page])]),
  metaInfo() {
    return { title: this.__("Operations") };
  },
  props: {
    operations: Object,
  },
  components: { Pagination },
  methods: {
    destroy(operation) {
      if (confirm(this.__('Delete :name?', { name: operation.name }))) {
        this.$inertia.delete(this.route('settings.operations.destroy', { operationCatalog: operation.id }), {
          preserveScroll: true,
        });
      }
    },
  },
};
</script>
